// M004-F0721 (design 4.7b "Release gate"): "Raise credit note" calls Core POST .../transactions/{handOffId}/credit-notes, which no
// deployed Core serves until Core #356. The pinned interface carries no can.* flag for credit notes, so the entry point is gated by
// this build-time flag, default OFF (tracked as "0" in .gitlab-ci.yml build + restore:testdeploy-main).
// Switch on (=1) only in the release that deploys Core #356. Only the exact string '1' enables.
export const isTxCreditNoteBackendAvailable = () => (
  process.env.REACT_APP_TX_CREDIT_NOTE_ENABLED === '1'
);

// M004-F0769..F0771 (WebUI #246 phase 2): the "View advice note" panel calls Core + the Ledger advice_note.preview op, which are not on
// prod until Core #521 and the Ledger op are deployed. Absent unless the build flag is exactly '1' (tracked as "0" in .gitlab-ci.yml build
// + restore:testdeploy-main and ci-build-flags.json). Both mounts gate on this; the phase 1 Advice card is not gated.
export const isAdviceStatementPanelEnabled = () => (
  process.env.REACT_APP_ADVICE_STATEMENT_ENABLED === '1'
);

// M004-F0778 (WebUI #250, Core #531): the room-controls panel (room state and target temperature via the Core relay) replaces the old
// ClimatePanel on the room page. Absent unless the build flag is exactly '1' (tracked as "0" in .gitlab-ci.yml build + restore:testdeploy-main
// and ci-build-flags.json). Off in every build until Core #531 is served on prod Core.
export const isRoomControlsRelayEnabled = () => process.env.REACT_APP_ROOM_CONTROLS_RELAY_ENABLED === '1';
